import { render, staticRenderFns } from "./BackToDashboard.vue?vue&type=template&id=181563af&scoped=true&"
var script = {}
import style0 from "./BackToDashboard.vue?vue&type=style&index=0&id=181563af&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181563af",
  null
  
)

export default component.exports